import { render, staticRenderFns } from "./SdsTin.vue?vue&type=template&id=1527571a&scoped=true&"
import script from "./SdsTin.vue?vue&type=script&lang=js&"
export * from "./SdsTin.vue?vue&type=script&lang=js&"
import style0 from "./SdsTin.vue?vue&type=style&index=0&id=1527571a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527571a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VForm,VRadio,VRadioGroup,VTextField})
